import { render, staticRenderFns } from "./DispensationDetails.vue?vue&type=template&id=6401d464&scoped=true&"
import script from "./DispensationDetails.vue?vue&type=script&lang=js&"
export * from "./DispensationDetails.vue?vue&type=script&lang=js&"
import style0 from "./DispensationDetails.vue?vue&type=style&index=0&id=6401d464&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6401d464",
  null
  
)

export default component.exports